import React from 'react';
import {Modal, Form, Input, InputNumber, message} from 'antd';
import {Upload} from '../../components';
import http from '../../libs/http';
import store from './store';

class ComForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    }
  }

  handleSubmit = () => {
    this.setState({loading: true});
    const formData = this.props.form.getFieldsValue();
    formData.id = store.subRecord.id;
    http.post(`/api/inspect/${store.record.id}/`, formData)
      .then(() => {
        message.success('操作成功');
        store.form2Visible = false;
        store.fetchRecords()
      }, () => this.setState({loading: false}))
  };

  render() {
    const info = store.subRecord;
    const {getFieldDecorator} = this.props.form;
    return (
      <Modal
        visible
        width={700}
        maskClosable={false}
        title={store.record.id ? '编辑检查项' : '新建检查项'}
        onCancel={() => store.form2Visible = false}
        confirmLoading={this.state.loading}
        onOk={this.handleSubmit}>
        <Form labelCol={{span: 6}} wrapperCol={{span: 14}}>
          <Form.Item required label="检查区域">
            {store.record.name}
          </Form.Item>
          <Form.Item required label="检查项">
            {getFieldDecorator('name', {initialValue: info['name']})(
              <Input placeholder="请输入菜单标题"/>
            )}
          </Form.Item>
          <Form.Item required label="分值">
            {getFieldDecorator('score', {initialValue: info['score']})(
              <InputNumber style={{width: '100%'}} placeholder="请输入该检查项的分值"/>
            )}
          </Form.Item>
          <Form.Item label="示例照片">
            {getFieldDecorator('pic', {initialValue: info['pic']})(
              <Upload maxCount={1} path="bait"/>
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(ComForm)